module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAP0lEQVQYlWP8//8/AxKAcRhhQkwMBABBBSxIxmKzCmwC3D4sgBFmBTZFYDFkNyArgrNBbsDQRRVfEGkCAwMDANtABx0QLI4BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/down_w.png
// module id = 69ET
// module chunks = 1